import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import PageHeader from "../../components/PageHeader";
import FileCard from "../../components/fileCard/FileCard";
import Loading from "../../components/Loading";
import styles from "./Manage.module.css";

import { apiUrl } from "../../utils/variables";
import dayjs from "dayjs";
import Swal from "sweetalert2";

const Deleted = () => {
  const token = useSelector((state) => state.auth.token);
  const [allFiles, setAllFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dateGroups, setDateGroups] = useState([]);

  useEffect(() => {
    const getAllFiles = async () => {
      const resp = await fetch(`${apiUrl}/documents/archived`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      const datesArr = [];

      data.forEach((archivedDoc) => {
        const dateString = dayjs(archivedDoc.dateArchived).format(
          "MMM DD, YYYY"
        );
        const index = datesArr.findIndex((element) => element === dateString);

        // if date is not in array yet. push a new dateString
        if (index === -1) {
          datesArr.push(dateString);
          return;
        }
      });
      setIsLoading(false);
      setAllFiles(data);
      setDateGroups(datesArr);
    };
    getAllFiles();
  }, [token]);

  const handleRestore = async (fileId) => {
    try {
      const resp = await fetch(`${apiUrl}/documents/unarchive/${fileId}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await resp.json();
      // console.log("result", result);
      if (result === true) {
        Swal.fire("Success", "Document has been restored", "success");
        setAllFiles(allFiles.filter((file) => file.id !== fileId));
      }
    } catch (error) {
      Swal.fire("Error", "There was an error in restoring your file", "error");
      console.log(error);
    }
  };

  const handleFilesDisplay = (fileGroup) => {
    return allFiles.map((file) => {
      const { id, fileName, lastEdited, createdBy, dateArchived } = file;
      // console.log(dateArchived);
      if (dayjs(dateArchived).format("MMM DD, YYYY") !== fileGroup) return null;
      return (
        <FileCard
          key={id}
          fileId={id}
          fileName={fileName}
          editDate={lastEdited}
          createdBy={createdBy.userName}
          isDeleted={true}
          action={handleRestore}
        />
      );
    });
  };

  const handleMainDisplay = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (allFiles.length > 0) {
      return dateGroups.map((fileGroup) => {
        return (
          <Box key={fileGroup}>
            <h2 className={styles.collectionName}>{fileGroup}</h2>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {handleFilesDisplay(fileGroup)}
            </Box>
          </Box>
        );
      });
    }

    return null;
  };

  return (
    <>
      <PageHeader>
        <Box>
          <h1>Deleted Files</h1>
          <p>
            Deleted files will be permanently deleted after 30 days from the
            date of deletion.
          </p>
        </Box>
      </PageHeader>

      <Box sx={{ paddingTop: "30px" }}>{handleMainDisplay()}</Box>
    </>
  );
};

export default Deleted;
